<div class="lang-switch">
	<div ngbDropdown placement="bottom-right">
		<button class="btn" ngbDropdownToggle>
			<span>{{ language | uppercase }}</span>
		</button>
		<div ngbDropdownMenu>
			<ng-container *ngFor="let lang of languages">
				<button
					[ngClass]="{ 'lang-selected': lang.label === language }"
					ngbDropdownItem
					(click)="setLanguage($event, lang.value)"
				>
					{{ lang.label | uppercase }}
				</button>
			</ng-container>
		</div>
	</div>
</div>
